{
  "aiGeneratedAnswer": "AI-generert svar",
  "allCategories": "Alle kategorier",
  "appliedFiltersToCurrentSearch": "Brukte filtre for gjeldende søk",
  "apply": "Bruk",
  "applyFilters": "Bruk filtre",
  "autocompleteOptionsFound_one": "{{count}}{{label}} autofullføringsvalg funnet.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} autofullføringsvalg funnet.",
  "autocompleteSuggestion": "autofullføringsforslag: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} autofullføringsforslag funnet.",
  "autocompleteSuggestionsFound_other": "{{count}} autofullføringsforslag funnet.",
  "basedOnYourDevice": " (basert på enheten din)",
  "basedOnYourInternetAddress": " (basert på din internettadresse)",
  "categoriesText_one": "Følgende kategori ga resultater for – <strong>{{query}}</strong>",
  "categoriesText_other": "Følgende kategorier ga resultater for – <strong>{{query}}</strong>",
  "clearAll": "Fjern alt",
  "clearMinAndMax": "Fjern min og maks",
  "clearTheRangeToSelectOptions": "Fjern området for å velge alternativer.",
  "clearTheSearchBar": "Tøm søkefeltet",
  "conductASearch": "Utfør et søk",
  "currentLocation": "Nåværende posisjon",
  "didYouMean": "Mente du <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Når autofullføringsresultater er tilgjengelige, bruk opp- og nedpiler for å bla gjennom og enter for å velge.",
  "feedback": "Tilbakemelding",
  "invalidRange": "Ugyldig område",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Gå til neste resultatside",
  "navigateToThePreviousResultsPage": "Gå til forrige resultatside",
  "noAutocompleteOptionsFound": "0 autofullføringsvalg funnet.",
  "noAutocompleteSuggestionsFound": "0 autofullføringsforslag funnet.",
  "noResultsFoundIn": "Ingen resultater funnet i {{currentVerticalLabel}}.",
  "pagination": "Sideinndeling",
  "readMoreAbout": "Les mer om <a>{{name}}</a>",
  "recentSearch": "siste søk: {{query}}",
  "recentSearchesFound_one": "{{count}} siste søk funnet.",
  "recentSearchesFound_other": "{{count}} siste søk funnet.",
  "removeFilter": "Fjern filteret “{{displayName}}”",
  "resultPreview": "resultatforhåndsvisning: {{value}}",
  "resultPreviewsFound_one": "{{count}} resultatforhåndsvisning funnet.",
  "resultPreviewsFound_other": "{{count}} resultatforhåndsvisninger funnet.",
  "resultsCountText_one": "{{count}} resultat",
  "resultsCountText_other": "{{count}} resultater",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} av {{resultsCount}} resultater",
  "searchHere": "Søk her…",
  "showLess": "Vis mindre",
  "showMore": "Vis mer",
  "showingAllInstead": "Viser alle {{currentVerticalLabel}} i stedet.",
  "sources_one": "Kilde",
  "sources_other": "Kilder ({{count}})",
  "submitSearch": "Send søk",
  "suggestionResultsCount_one": "{{label}} - {{count}} resultat",
  "suggestionResultsCount_other": "{{label}} - {{count}} resultater",
  "thankYouForYourFeedback": "Takk for tilbakemeldingen!",
  "thisAnsweredMyQuestion": "Dette besvarte spørsmålet mitt",
  "thisDidNotAnswerMyQuestion": "Dette besvarte ikke spørsmålet mitt",
  "unselectAnOptionToEnterInARange": "Fjern valg for å angi et område.",
  "updateYourLocation": "Oppdater plasseringen din",
  "useCurrentLocation": "Bruk nåværende posisjon",
  "useMyLocation": "Bruk min posisjon",
  "viewAll": "Se alle",
  "viewDetails": "Se detaljer"
}
